// extracted by mini-css-extract-plugin
module.exports = {"component":"review-form_component_25lnc","rating":"review-form_rating_3QqaK","star":"review-form_star_1hCCs","actions":"review-form_actions_1IEB6"};